import male from '../assets/international-male.png';
import female from '../assets/international-female.png';

export default { male, female };
